import React, { ReactNode } from 'react';

import Avatar from 'components/avatar';
import * as S from './styles';

interface IProps {
  name?: string | null;
  /** The quieter second line — an address, a job title, both. */
  meta?: ReactNode;
  /** Their picture. Falls back to initials. */
  src?: string | null;
  /** Usually a StatusChip saying what they are here for. Sits at the far end. */
  badge?: ReactNode;
  className?: string;
}

/**
 * The design's `.person` — one person on a card.
 *
 *   <Person name="Riza Asghari" meta="riza@frontline.sa · Technical Architect"
 *           src={profilePicture} badge={<StatusChip domain="reservationRole" value="organizer" />} />
 *
 * Shared because the design draws it twice: the reservation detail's People
 * section and the notification composer's selected-recipients list.
 *
 * Both lines clip with an ellipsis rather than wrapping, and neither is cut
 * in JavaScript. The screen this replaces truncated the name at 15
 * characters, the job title at 15 and the address at 25 — fixed counts,
 * applied at every card width, with no way to see the rest. `Technical
 * Architect` is 19 characters, so every organizer on the screen read
 * `Technical Archi...` in a card with room to spare.
 */
const Person: React.FC<IProps> = ({ name, meta, src, badge, className }) => (
  <S.Person className={className}>
    <Avatar src={src} name={name} size="lg" />
    <S.Who>
      <S.Name title={name || undefined}>{name}</S.Name>
      {meta ? <S.Meta>{meta}</S.Meta> : <></>}
    </S.Who>
    {badge ? <S.Badge>{badge}</S.Badge> : <></>}
  </S.Person>
);

export default Person;
